import { Linkify } from '@/components/shared/components/Linkify';
import { DDDRow, DDDRowLabel, DDDRowList, DDDRowValue } from '../Applicant.StyledComponents';

interface KeyValuePairProps extends React.ComponentPropsWithRef<'div'> {
    dataTestId: string;
    label: string;
    value?: React.ReactNode | string | number | boolean;
}

export const ApplicantKeyValuePair = ({
    dataTestId,
    label,
    value,
    ...props
}: KeyValuePairProps) => {
    if (typeof value === 'number' || typeof value === 'boolean') {
        value = String(value);
    }
    const hasValue = value != null && value !== '';
    const displayValue = hasValue ? value : 'Unknown';
    return (
        <DDDRow {...props} data-testid={dataTestId}>
            <DDDRowLabel>{label}</DDDRowLabel>
            <DDDRowValue>
                {typeof displayValue === 'string' ? <Linkify>{displayValue}</Linkify> : displayValue}
            </DDDRowValue>
        </DDDRow>
    );
};

export const ApplicantKeyValueTable = (props: React.ComponentPropsWithRef<'div'>) => <DDDRowList {...props} />;
